// SignIn.jsx  ⇢  REPLACE THE OLD FILE
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

import { useAuth } from "../context/AuthContext";
import Navbar from "./navbar";

export default function SignIn() {
  const [msg, setMsg] = useState({ type: "", text: "" });

  const navigate  = useNavigate();
  const location  = useLocation();
  const { login } = useAuth();          // same helper you already use

  // take API base from env (works for Vite or CRA)
  const API =
    import.meta?.env?.VITE_API_URL ||
    process.env.REACT_APP_API_URL ||
    "https://api.kodanza.com";

  const onGoogleSuccess = async (credentialResponse) => {
    try {
      const { data } = await axios.post(
        `${API}/auth/google`,
        { idToken: credentialResponse.credential },
        { withCredentials: true }
      );

      login(data.token, data.user);     // store JWT / user in context
      setMsg({ type: "success", text: "Signed in! Redirecting…" });

      const dest = location.state?.from || "/lessons";
      setTimeout(() => navigate(dest, { replace: true }), 500);
    } catch (err) {
      console.error(err);
      const txt =
        err.response?.data?.error || "Google sign-in failed – try again";
      setMsg({ type: "error", text: txt });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* shared navbar */}
      <Navbar />

      {/* hero band with wave */}
      <header className="relative bg-rose-50 pb-20">
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#fff1f0"
            d="M0,64L80,85.3C160,107,320,149,480,138.7C640,128,800,64,960,74.7C1120,85,1280,171,1360,213.3L1440,256L1440,0 0 0Z"
          />
        </svg>

        {/* card */}
        <div className="relative flex items-center justify-center mt-24 px-6">
          <div className="max-w-md w-full bg-white p-10 shadow-2xl rounded-2xl">
            <h2 className="text-3xl font-bold mb-8 text-center">
              Sign in to Kodanza
            </h2>

            {msg.text && (
              <p
                className={`mb-6 text-center ${
                  msg.type === "success" ? "text-green-600" : "text-red-600"
                }`}
              >
                {msg.text}
              </p>
            )}

            {/* Google button */}
            <div className="flex justify-center">
              <GoogleLogin
                onSuccess={onGoogleSuccess}
                onError={() =>
                  setMsg({ type: "error", text: "Google sign-in cancelled" })
                }
                useOneTap
              />
            </div>

            <p className="mt-6 text-center text-gray-500 text-sm">
              We use Google to keep your account secure—no passwords needed.
            </p>
          </div>
        </div>
      </header>
    </div>
  );
}
